import { VoiceTurnState } from '@euler/components/voice-input/functions/useVoiceTurn';
import { useEffect } from 'react';
import { BehaviorSubject, distinctUntilChanged, map, skip } from 'rxjs';

/**
 * The silence hint waits while the trainee talks. It follows the voice
 * turn, not the button: a hands-free capture can end without one (an
 * error, the length limit, the final never coming), and the hint must
 * come back then too.
 */
export function useVoiceHintHold(
  state$: BehaviorSubject<VoiceTurnState>,
  hints: { press: () => void; settle: () => void },
) {
  const { press, settle } = hints;
  useEffect(() => {
    const subscription = state$
      .pipe(
        map(state => state.kind !== 'idle'),
        distinctUntilChanged(),
        // Idle to begin with: nothing to let go of.
        skip(1),
      )
      .subscribe(talking => (talking ? press() : settle()));
    return () => subscription.unsubscribe();
  }, [press, settle, state$]);
}
